// Per-group page — reached by clicking a Portal Group card on the homepage.
// Lists every request type inside the group (JSM "portal group" drill-down).
import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { usePortal } from './PortalLayout';
import PortalRtCard from './PortalRtCard';

export default function PortalGroupPage() {
  const { groupId, slug } = useParams();
  const { portal, groups, request_types } = usePortal();
  const theme = portal.branding?.theme_color || '#2563eb';

  const group = useMemo(() => groups.find(g => g.group_id === groupId), [groups, groupId]);
  const items = useMemo(
    () => request_types.filter(rt => rt.portal_group_id === groupId),
    [request_types, groupId]
  );

  if (!group) return (
    <div className="bg-white border border-zinc-200 rounded-lg p-8 text-center">
      <p className="text-sm text-zinc-500">Group not found. <Link to={`/help/${slug}`} className="text-blue-600 underline">Go back</Link></p>
    </div>
  );

  return (
    <div className="space-y-6" data-testid="portal-group-page">
      <Link to={`/help/${slug}`} className="inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-900">
        <ArrowLeft size={14} /> Back to portal
      </Link>

      {group.image_url && (
        <div className={`h-44 w-full rounded-xl ring-1 ring-zinc-200 ${(group.image_fit || 'contain') === 'contain' ? 'bg-contain bg-no-repeat bg-center bg-zinc-50' : 'bg-cover bg-center'}`}
          style={{ backgroundImage: `url('${group.image_url}')` }} aria-hidden />
      )}

      <div>
        <h1 className="text-2xl font-bold text-zinc-900 font-['Outfit']">{group.name}</h1>
        {group.description && <p className="text-sm text-zinc-500 mt-1 max-w-2xl">{group.description}</p>}
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-lg p-12 text-center">
          <p className="text-sm text-zinc-500">No request types in this group yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map(rt => (
            <PortalRtCard key={rt.request_type_id} rt={rt} slug={slug} theme={theme} />
          ))}
        </div>
      )}
    </div>
  );
}
